<template>
  <!-- 直接渲染已有的svg -->
  <IconifyIcon v-if="!isExit" v-bind="$attrs" :class="svgClass" :style="styleIconifyIcon" :icon="icon" />
  <!-- 渲染外部链接的svg -->
  <div v-else v-bind="$attrs" :class="svgClass" :style="styleExternalIcon" bg-current></div>
</template>

<script>
import { Icon as IconifyIcon } from '@iconify/vue2';
import { isExternal } from '@/utils/validate';

export default {
  components: {
    IconifyIcon
  },
  props: {
    icon: String,
    customClass: String,
    width: String,
    height: String,
  },
  computed: {
    // 是否外联svg
    isExit(){
      return isExternal(this.icon);
    },
    // 增添后的自定义类名
    svgClass(){
      return this.customClass ? `svg-icon ${this.customClass}` : 'svg-icon';
    },
    // iconify图标样式
    styleIconifyIcon(){
      const {width, height} = this;
      const result = {};
      if (width) {
        result.width = width;
        result.height = width;
      }
      if (height) result.height = height;
      return result
    },
    // 如果svg是带协议的图标链接 则通过style css属性⽅式渲染
    // 通过 mask 渲染svg图标，兼容性不好；可以通过请求svg的方式来渲染
    styleExternalIcon(){
      const {icon} = this;
      return {
        '-webkit-mask': `url(${icon}) no-repeat 50% 50%`,
        'mask': `url(${icon}) no-repeat 50% 50%`,
        'mask-size': 'cover',
        'display': 'inline-block'
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.svg-icon {
  // @apply size-1em vertical-middle color-current overflow-hidden;
  /* fill: currentColor; */
  width: 16px;
  height: 16px;
  vertical-align: middle;
  color: currentColor;
  overflow: hidden;
}
</style>